export const BEAD = {
    label: 'Bead',
    value: 'BEAD'
};

export const ABSORB = {
    label: 'Absorb',
    value: 'ABSORB'
};